import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { CardAccount } from '../feature-modules/accounts/models/accounts.model';

interface SamlRouterState {
  saml?: string;
  secondLevelValidated?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SamlGuard {
  constructor(
    private readonly router: Router,
    private readonly location: Location
  ) {}

  canActivate(): boolean {
    let creditAccount: Pick<CardAccount, 'secondLevelValidated'> | null = null;
    try {
      creditAccount = JSON.parse(localStorage.getItem('bestegg_credit_card_session'));
    } catch {
      localStorage.removeItem('bestegg_credit_card_session');
    }
    const currentNav = this.router.getCurrentNavigation();
    const routerState = (currentNav
      ? currentNav.extras?.state
      : this.location.getState()) as SamlRouterState;
    const isSecondLevelValidated = routerState?.secondLevelValidated ?? creditAccount?.secondLevelValidated;

    if (routerState?.saml && isSecondLevelValidated) {
      return true;
    }

    this.router.navigate(['/customer-hub'], { state: { isLaunchingCardVerificationModal: true } });
    return false;
  }
}
